
<!-- 
SendResultModal.vue
功能：寄送資格/訊息發送狀態視窗(生日優禮&EDM)
作者：i9400538 陳博承
完成：2022-01-22
-->
<template>
  <div id="send-result-modal" class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content" :class="{'section-loading': queryLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">寄送資格/訊息發送狀態</h3>
        </div>
        <div class="modal-body">
          <template>
            <div class="row">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th id="th_item" class="text-center">項目</th>
                    <th id="th_msg" class="text-center">簡訊/Email</th>
                    <th id="th_send_status" class="text-center">發送狀態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in tableData" :key="`table-item-send-result-${i}`">
                    <td class="text-center">{{item.sns_project_name}}</td>
                    <td class="text-center">{{item.sns_name}}</td>
                    <td class="text-center">
                      <span v-if="item.send_date">
                        {{item.send_date | dateFormat}}
                        <br />
                      </span>
                      <span v-if="item.sns_name == '簡訊'">{{item.sns_open_status | getMsgText}}</span>
                      <span v-else>{{item.sns_open_status | getEmailText}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
//service
import { getSendResult } from "@/service";
export default {
  name: "SendResultModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    csid: {
      type: String,
      default: ""
    },
    api_id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      queryLoading: false
    };
  },
  filters: {
    //寄發簡訊狀態
    getMsgText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "0") {
        text = "預約傳送中";
      } else if (val == "1") {
        text = "已送達業者";
      } else if (val == "2") {
        text = "已送達業者";
      } else if (val == "3") {
        text = "已送達業者";
      } else if (val == "4") {
        text = "已送達手機";
      } else if (val == "5") {
        text = "內容有錯誤";
      } else if (val == "6") {
        text = "門號有錯誤";
      } else if (val == "7") {
        text = "簡訊已停用";
      } else if (val == "8") {
        text = "逾時無送達";
      } else if (val == "9") {
        text = "預約已取消";
      } else if (val == "A") {
        text = "已推播";
      } else if (val == "R") {
        text = "推播未讀改發簡訊";
      } else if (val == "B") {
        text = "即時簡訊、OTP驗證簡訊備份";
      } else if (val == "L") {
        text = "LINE BC已推播 ";
      } else if (val == "*") {
        text = "系統發送錯誤，請聯絡三竹資訊窗口人員";
      } else if (val == "a") {
        text = "簡訊發送功能暫時停止服務，請稍候再試";
      } else if (val == "b") {
        text = "簡訊發送功能暫時停止服務，請稍候再試";
      } else if (val == "c") {
        text = "請輸入帳號";
      } else if (val == "d") {
        text = "請輸入密碼";
      } else if (val == "e") {
        text = "帳號、密碼錯誤";
      } else if (val == "f") {
        text = "帳號已過期";
      } else if (val == "h") {
        text = "帳號已被停用";
      } else if (val == "k") {
        text = "無效的連線位址";
      } else if (val == "l") {
        text = "帳號已達到同時連線數上限";
      } else if (val == "m") {
        text = "必須變更密碼，在變更密碼前，無法使用簡訊發送服務";
      } else if (val == "n") {
        text = "密碼已逾期，在變更密碼前，將無法使用簡訊發送服務";
      } else if (val == "p") {
        text = "沒有權限使用外部Http程式";
      } else if (val == "r") {
        text = "系統暫停服務，請稍後再試";
      } else if (val == "s") {
        text = "帳務處理失敗，無法發送簡訊";
      } else if (val == "t") {
        text = "簡訊已過期";
      } else if (val == "u") {
        text = "簡訊內容不得為空";
      } else if (val == "v") {
        text = "無效的手機號碼";
      } else if (val == "w") {
        text = "查詢筆數超過上限";
      } else if (val == "x") {
        text = "發送檔案過大，無法發送簡訊";
      } else if (val == "y") {
        text = "參數錯誤 ";
      } else if (val == "z") {
        text = "查無資料";
      }

      return text;
    },
    //寄發Email狀態
    getEmailText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "-2") {
        text = "MailHunter:重複E-Mail";
      } else if (val == "-1") {
        text = "BillHunter:抽件 MailHunter:黑名單";
      } else if (val == "0") {
        text = "寄送成功";
      } else if (val == "1") {
        text = "郵件地址錯誤";
      } else if (val == "2") {
        text = "信箱空間不足";
      } else if (val == "3") {
        text = "無此使用者";
      } else if (val == "4") {
        text = "IP被封鎖";
      } else if (val == "5") {
        text = "逾時終止";
      } else if (val == "6") {
        text = "系統驗證錯誤";
      } else if (val == "7") {
        text = "使用者中斷";
      } else if (val == "8") {
        text = "退信失敗";
      } else if (val == "9") {
        text = "組信失敗";
      } else if (val == "21") {
        text = "寄送中";
      } else if (val == "open") {
        text = "信件已讀取";
      }
      return text;
    }
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.tableData = [];
      this.sendLoading = false;
      this.doQuery();
    },
    //呼叫API查詢
    doQuery() {
      this.queryLoading = true;
      getSendResult(this.$store.state.userInfo.id, this.csid, this.api_id).then(
        result => {
          this.queryLoading = false;
          if (result.header && result.header.status === "200") {
            this.tableData = result.body.result.map(item => {
              item.send_date = item.sns_open_time
                ? item.sns_open_time.substring(0, 10)
                : "";
              return item;
            });
          } else {
            this.setToastMsg("查詢失敗 : " + result.header.message);
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>